<top-menu-svg-sprite />
<close-icon-svg/>

@if (dataSig(); as data) {
  @if (!isFullScreenMode()) {
    @if (useNewDesign()) {
      <!-- 2026 header/footer redesign (default; tenants can opt back into classic via Admin => Settings => Navigation). Classic markup below is untouched. -->
      @if (headerVm(); as vm) {
        <och-header
          [vm]="vm"
          [navLinks]="headerNavLinks()"
          [continueWatching]="continueWatching()"
          (click)="closeAiGlobalChat()"
          (navAction)="onHeaderNavAction($event)"
          (loginClicked)="login(false, data?.tenant)"
          (logoutClicked)="logout(data?.tenant, data?.user?.id)"
          (upgradeClicked)="onUpgradeBtnClicked(data)"
          (aiAssistantClicked)="toggleAiChat($event, data?.tenant)"
          (notificationsToggled)="toggleNotificationDialog(data?.user?.id, data?.user?.unreadNotificationsCounter)"
          (popoverOpened)="closeNotificationDialog()"
          (accountMenuOpened)="onAccountMenuOpened()"
          (searchSelected)="onHeaderSearchSelected($event)"
        />
        @if (isCommunityVisible(data)) {
          @defer (when isOpenNotification()) {
            @if (isOpenNotification()) {
              <div class="notifications">
                <notification-dialog [user]="data?.user" (closeNotificationDialog)="closeNotificationDialog()" />
              </div>
            }
          }
        }
      }
    } @else {
    <div class="navbar" (click)="closeAiGlobalChat()" #navBarContainer>
      <div class="navbar-wrapper ">
        @if (isPlatformSite) {
          <div class="navbar-brand">
            <a target="_blank" href="https://onlinecoursehost.com">
              <img class="hat-logo" src="https://d8avu785lzlph.cloudfront.net/images/logos/och-hat-v1.svg" />
            </a>
          </div>
        }
        <div class="navbar-left">
          @if (!isPlatformSite && !isTenantLoginPage) {
            <button class="toggle-menu" (click)="toggleMenu()">
              <span class="material-symbols-outlined">
                {{isOpen() ? 'close' : 'menu'}}
              </span>
            </button>
          }
          @if (!isSingleSignOnPage && !isPlatformSite) {
            @if (!isLandingPageMode()) {
              <ul class="menu">
                @if (data?.tenant?.topMenuLogoConfig?.topMenuLogoUrl) {
                  <li class="menu-item app-logo" routerLink="/home">
                    <!-- @if (data?.tenant?.homePageOn) { -->
                    <img class="logo" [src]="data?.tenant?.topMenuLogoConfig?.topMenuLogoUrl" />
                    <!-- } -->
                  </li>
                }
              </ul>
            }
          }
          <div class="navbar-menu" [class.open]="isOpen()" #navBarLeftMenu>
            @if (!isSingleSignOnPage && !isPlatformSite) {
              @if (!isLandingPageMode()) {
                <ul class="menu">
                  <!-- @if ((data?.tenant?.disableStartHere === false || data?.tenant?.disableStartHere === undefined)
                    && featureFlagService.features.onBoardingTutorials) {
                    @if (showOnBoardingTutorials(data)) {
                      <li class="menu-item" (click)="toggleMenu()">
                        <a class="menu-item-link" routerLink="/onboarding-tutorials" routerLinkActive="active">OCH Academy</a>
                      </li>
                    }
                  } -->
                  @if (data?.tenant?.homePageOn) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          home
                        </span>
                      </div>
                      @if (data?.tenant?.homePageOn) {
                        <a class="menu-item-link" routerLink="/home" routerLinkActive="active"
                        >{{ "menu.home" | translate }}</a>
                      }
                    </li>
                  }
                  <li class="menu-item" (click)="toggleMenu()">
                    <div class="menu-item-icon">
                      <span class="material-symbols-outlined">
                        sticky_note_2
                      </span>
                    </div>
                    <a class="menu-item-link" routerLink="/courses" routerLinkActive="active">{{ "menu.products" |
                      translate }}
                    </a>
                  </li>
                  @if ((isCommunityVisible(data))) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          sticky_note_2
                        </span>
                      </div>
                      <a class="menu-item-link" routerLink="/community" routerLinkActive="active">{{
                        "community.common.community" |
                        translate }}
                      </a>
                    </li>
                  }
                  @if (!data?.tenant?.allLessonsTabOff) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          smart_display
                        </span>
                      </div>
                      <a class="menu-item-link" routerLink="/all-lessons" routerLinkActive="active">{{ "menu.allLessons" |
                        translate }}
                      </a>
                    </li>
                  }
                  @if (data.showSubscription && !data?.tenant?.subscriptionScreenDisabled) {
                    <li class="menu-item"
                      (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          card_membership
                        </span>
                      </div>
                      <a class="menu-item-link" routerLink="/subscription" routerLinkActive="active">{{ "menu.subscription"
                        |
                        translate
                      }}</a>
                    </li>
                  }
                  @if(isPageBuilderVisible(data)) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          sticky_note_2
                        </span>
                      </div>
                      <a class="menu-item-link" routerLink="/page-builder/site-pages" routerLinkActive="active">
                        {{ "menu.pageBuilder" | translate }}
                      </a>
                    </li>
                  }
                  @if (!data?.tenant?.contactPageDisabled) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          contact_support
                        </span>
                      </div>
                      <a class="menu-item-link" routerLink="/contact" routerLinkActive="active">{{
                      "menu.contact" | translate }}</a>
                    </li>
                  }
                  <ng-container *denyRole="['ADMIN']">
                    @if (!data?.tenant?.newsletter?.newsletterFormDisabled) {
                      <li class="menu-item" (click)="toggleMenu()">
                        <div class="menu-item-icon">
                          <span class="material-symbols-outlined">
                            mail
                          </span>
                        </div>
                        <span class="menu-item-link" (click)="showNewsletterPopup()" *allowPlan="'basic'">{{
                        "menu.newsLetter" | translate }}</span>
                      </li>
                    }
                  </ng-container>
                  @if (isAdminMenuAllowed(data)) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <div class="menu-item-icon">
                        <span class="material-symbols-outlined">
                          admin_panel_settings
                        </span>
                      </div>
                      <a class="menu-item-link" [routerLink]="adminMenuLink(data)" routerLinkActive="active">{{
                      "menu.admin" | translate }}</a>
                    </li>
                  }
                  @for (menuEntry of firstExtraMenuEntries(); track index; let index = $index) {
                    <li class="menu-item" (click)="toggleMenu()">
                      <a class="menu-item-link" [href]="menuEntry.link"
                        [target]="menuEntry?.targetTabState ? '_blank' : '_self'">
                        {{ menuEntry.title }}
                      </a>
                    </li>
                  }
                  <!-- These go inside a "More" dropdown if there isn't enough space -->
                  @if (moreMenuEntries().length > 0) {
                    <li class="menu-item">
                      <div class="menu-item-link d-flex align-items-center" [matMenuTriggerFor]="moreMenu"
                        #trigger="matMenuTrigger">
                        <span>{{ "menu.more" | translate }}</span>
                        <svg class="expand-icon" [class.rotated]="trigger.menuOpen">
                          <use xlink:href="#arrowDownWhite"></use>
                        </svg>
                      </div>
                      <mat-menu #moreMenu="matMenu" class="dropdown-menu">
                        @for (customMenu of moreMenuEntries(); track customMenu) {
                          <a class="drop-menu-item" mat-menu-item (click)="toggleMenu()" [href]="customMenu?.link"
                            [target]="customMenu?.targetTabState ? '_blank' : '_self'">
                            <span class="menu-text">{{ customMenu?.title }}</span>
                          </a>
                        }
                      </mat-menu>
                    </li>
                  }
                  <!--  Custom Menu end -->
                  <!-- Student Settings Start -->
                  @if (data?.isLoggedIn) {
                    <li class="menu-item" *denyRole="['ADMIN']">
                      <div class="menu-item-link  d-flex align-items-center" [matMenuTriggerFor]="menuItemTwo"
                        #trigger="matMenuTrigger">
                        <span>{{ "menu.settings" | translate }}</span>
                        <svg class="expand-icon" [class.rotated]="trigger.menuOpen">
                          <use xlink:href="#arrowDownWhite"></use>
                        </svg>
                      </div>
                      <mat-menu #menuItemTwo="matMenu" class="dropdown-menu">
                        <a mat-menu-item class="drop-menu-item" (click)="toggleMenu()"
                          routerLink="/user-settings/my-account">
                          <span class="menu-text">{{ "menu.myAccount" | translate }}</span>
                        </a>
                        @if (!data?.tenant?.disableMyCertificatesScreen) {
                          <a mat-menu-item class="drop-menu-item"
                            (click)="toggleMenu()" routerLink="/user-settings/my-certificates">
                            <span class="menu-text">{{ "menu.myCertificates" | translate }}</span>
                          </a>
                        }
                        @if (data?.tenant?.affiliateProgramSettings?.enabled) {
                          <a mat-menu-item class="drop-menu-item"
                            (click)="toggleMenu()" routerLink="/user-settings/my-affiliate-program">
                            <span class="menu-text">{{('menu.joinAffiliateProgram' | translate )}}</span>
                          </a>
                        }
                        @if (!data?.tenant?.platformLabelling?.disableCreateYourCourseStudentMenu) {
                          <a mat-menu-item class="drop-menu-item"
                            (click)="toggleMenu()" href="https://onlinecoursehost.com" target="_blank">
                            <span class="menu-text">{{('menu.createYourCourse' | translate )}}</span>
                          </a>
                        }
                      </mat-menu>
                    </li>
                  }
                </ul>
              }
            }
          </div>
        </div>
        <div class="navbar-right" #navBarRightMenu>
          <ul class="auth-btns">
            <li>
              <trial-expiration></trial-expiration>
            </li>
            @if(isUpgradeButtonVisible(data)) {
              <li>
                <button class="upgrade-plan-btn" (click)="onUpgradeBtnClicked(data)">
                  <svg>
                    <use xlink:href="#upgradeIcon"></use>
                  </svg>
                  <!-- <span>Upgrade{{ "menu.Upgrade" | translate }}</span> -->
                  <span>Upgrade</span>
                </button>
              </li>
            }
            <li *allowRole="['ADMIN']">
              <button class="aiButton" (click)="toggleAiChat($event, data?.tenant)">
                <global-ai-icon-svg />
                <span>AI Assistant</span>
              </button>
            </li>
            @if (isCommunityVisible(data)) {
              <li>
                <button #openNotificationsDialogButton class="notify-btn"
                  (click)="toggleNotificationDialog(data?.user?.id, data?.user?.unreadNotificationsCounter)">
                  <svg>
                    <use xlink:href="#bellIcon"></use>
                  </svg>
                  @if(data?.user?.unreadNotificationsCounter > 0) {
              <span class="counter" [style.background]="data?.tenant.brandTheme.accentColor">
                      {{data?.user?.unreadNotificationsCounter}}
                    </span>
                  }
                </button>
                @defer(on hover(openNotificationsDialogButton)){
                @if (isOpenNotification()) {
                  <div class="notifications">
                    <notification-dialog [user]="data?.user" (closeNotificationDialog)="closeNotificationDialog()" />
                  </div>
                }
              }
            </li>
          }
          @if (data?.isLoggedIn && data?.user?.testUser) {
            <li>
              <div class="test-pill"
                matTooltip="Your user is currently a Stripe test user. All interactions with Stripe like course purchase etc. will be with fake credit cards like 424242. Notice that to perform the initial connection to Stripe, you can't be in Test mode.">
                Test
              </div>
            </li>
          }
          @if (data?.isLoggedOut) {
            <li>
              <button class="login-button" id="loginButton" (click)="login(false, data?.tenant)">
                <label>{{ "menu.login" | translate }}</label>
                <svg>
                  <use xlink:href="#loginIcon"></use>
                </svg>
              </button>
            </li>
          }
          @if (data?.pictureUrl) {
            <li>
              <img class="user-avatar" [src]="data?.pictureUrl" />
            </li>
          }
          @if (data?.isLoggedIn) {
            <li>
              <button class="logout-button" (click)="logout(data?.tenant, data?.user?.id)">
                <svg>
                  <use xlink:href="#logOutIcon"></use>
                </svg>
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
    }
  }
}
